export default __webpack_public_path__ + "static/media/link-icon.ea53e2a6.svg";